"use strict";
const utils = require("./utils-8c_2IZTy.js");
const React = require("react");
function $a1ea59d68270f0dd$export$f8168d8dd8fd66e6(props) {
  let { isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange } = props;
  const onBlur = React.useCallback((e) => {
    if (e.target === e.currentTarget) {
      if (onBlurProp) onBlurProp(e);
      if (onFocusChange) onFocusChange(false);
      return true;
    }
  }, [
    onBlurProp,
    onFocusChange
  ]);
  const onSyntheticFocus = utils.$8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
  const onFocus = React.useCallback((e) => {
    const ownerDocument = utils.$431fbd86ca7dc216$export$b204af158042fbac(e.target);
    const activeElement = ownerDocument ? utils.$d4ee10de306f2510$export$cd4e5573fbe2b576(ownerDocument) : utils.$d4ee10de306f2510$export$cd4e5573fbe2b576();
    if (e.target === e.currentTarget && activeElement === utils.$d4ee10de306f2510$export$e58f029f0fbfdb29(e.nativeEvent)) {
      if (onFocusProp) onFocusProp(e);
      if (onFocusChange) onFocusChange(true);
      onSyntheticFocus(e);
    }
  }, [
    onFocusChange,
    onFocusProp,
    onSyntheticFocus
  ]);
  return {
    focusProps: {
      onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : void 0,
      onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : void 0
    }
  };
}
exports.$a1ea59d68270f0dd$export$f8168d8dd8fd66e6 = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6;
